var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "gantt-elastic__calendar-wrapper",
      style: Object.assign({}, _vm.root.style["calendar-wrapper"], {
        width: _vm.width + "px"
      })
    },
    [
      _c(
        "div",
        {
          staticClass: "gantt-elastic__calendar",
          style: Object.assign({}, _vm.root.style["calendar"], {
            width: _vm.width + "px"
          })
        },
        [
          _vm.calendar.decade.display
            ? _c("calendar-row", {
                attrs: { items: _vm.dates.decades, which: "decade" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.calendar.year.display
            ? _c("calendar-row", {
                attrs: { items: _vm.dates.years, which: "year" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.calendar.quarter.display
            ? _c("calendar-row", {
                attrs: { items: _vm.dates.quarters, which: "quarter" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.calendar.month.display
            ? _c("calendar-row", {
                attrs: { items: _vm.dates.months, which: "month" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.calendar.week.display
            ? _c("calendar-row", {
                attrs: { items: _vm.dates.weeks, which: "week" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.calendar.day.display
            ? _c("calendar-row", {
                attrs: { items: _vm.dates.days, which: "day" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.calendar.hour.display
            ? _c("calendar-row", {
                attrs: { items: _vm.dates.hours, which: "hour" }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }